import React, { Component } from 'react';
import { Link } from 'react-router'
import { Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from './../../actions/auth';
import { AUTH_INFO_KEY } from '../../config/session';

const storage = window.localStorage;

@connect(
  state => ({ auth: state.get('Auth') }),
  dispatch => bindActionCreators(actionCreators, dispatch)
)
class Sidebar extends Component {
  state = {
    display2: 'none',
    display1: 'block'
  }
  componentWillMount() {
    // const { auth } = this.props;
    // const data = (auth.toJS() && auth.toJS().data && auth.toJS().data.data) || '';
    // const code = (data.user && data.user.code) || '';
    // if (code === 'bsc') {
    //   this.setState({
    //     display1: 'none',
    //     display2: 'block'
    //   })
    // } else if (code === '') {
    //   browserHistory.push('/pages/login');
    // }
    const user = JSON.parse(storage.getItem(AUTH_INFO_KEY));
    if (user && user.code === 'bsc') {
      this.setState({
        display1: 'none',
        display2: 'block'
      })
    }
    // console.log('nikuaidianchulai-----------', user.code)
  }
  handleClick = (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute = (routeName) => {
    const { location } = this.props;
    const { pathname } = location;
    const className = 'nav-item nav-dropdown';
    return pathname.indexOf(routeName) > -1 ? `${className} open` : className;
  }

  render() {
    const { display1, display2 } = this.state;
    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            <li className="nav-item">
              <Link to={'/dashboard'} className="nav-link" activeClassName="active"><i className="icon-speedometer" /> 工作台 <span className="badge badge-info">NEW</span><div className="triangle" /></Link>
            </li>
            <div style={{ display: display1 }}>
              <li className="nav-item">
                <Link to={'/qrimage'} className="nav-link" activeClassName="active"><Icon type="picture" /> 照片审批 <div className="triangle" /></Link>
              </li>
              {/* <li className="nav-item">
              <Link to={'/audit'} className="nav-link" activeClassName="active"><Icon type="exception" /> 审计记录 <div className="triangle" /></Link>
            </li>
             <li className={this.activeRoute('/forms')}>
              <a className="nav-link nav-dropdown-toggle" onClick={this.handleClick}><Icon type="wechat" /> 小程序管理 </a>
              <ul className="nav-dropdown-items">
                <li className="nav-item">
                  <Link to={'/basic'} className="nav-link nav-child" activeClassName="active"><Icon type="bars" /> 轮播图管理 <div className="triangle" /></Link>
                </li>
                <li className="nav-item">
                  <Link to={'/advanced'} className="nav-link nav-child" activeClassName="active"><Icon type="notification" /> 通知管理 <div className="triangle" /></Link>
                </li>
              </ul>
            </li> */}
              <li className={this.activeRoute('/forms')}>
                <a className="nav-link nav-dropdown-toggle" onClick={this.handleClick}><Icon type="user" /> 经销商管理 </a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <Link to={'/user'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 用户管理 <div className="triangle" /></Link>
                  </li>
                  <li className="nav-item">
                    <Link to={'/register/user'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 新增用户 <div className="triangle" /></Link>
                  </li>
                  <li className="nav-item">
                    <Link to={'/register/customer'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 新增经销商 <div className="triangle" /></Link>
                  </li>
                </ul>
              </li>
              <li className={this.activeRoute('/forms')}>
                <a className="nav-link nav-dropdown-toggle" onClick={this.handleClick}><Icon type="user" /> 积分管理 </a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <Link to={'/score'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 用户积分 <div className="triangle" /></Link>
                  </li>
                  <li className="nav-item">
                    <Link to={'/score/exchange'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 兑换记录 <div className="triangle" /></Link>
                  </li>
                  <li className="nav-item">
                    <Link to={'/score/log'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 积分流水 <div className="triangle" /></Link>
                  </li>
                </ul>
              </li>
            </div>
            <div style={{ display: display2 }}>
              <li className={this.activeRoute('/forms')}>
                <a className="nav-link nav-dropdown-toggle" onClick={this.handleClick}><Icon type="user" /> 任务管理 </a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <Link to={'/newTasks'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 派发任务 <div className="triangle" /></Link>
                  </li>
                  <li className="nav-item">
                    <Link to={'/queryTasks'} className="nav-link nav-child" activeClassName="active"><Icon type="user-add" /> 查看任务 <div className="triangle" /></Link>
                  </li>
                </ul>
              </li>
            </div>
          </ul>
        </nav>
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./components/Sidebar/index.js